import { render, staticRenderFns } from "./ModalPublishForm.vue?vue&type=template&id=13a00f6a&"
import script from "./ModalPublishForm.vue?vue&type=script&lang=js&"
export * from "./ModalPublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports